import { Fragment, useEffect, useMemo, useState } from "react";
import ReactTable from 'react-table';
import { VerticalDotsSvg } from "../../assets/svgs";
import { BackButton, BadgeComponent, Breadcrumbs, DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent, ViewHistoryModal } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { handleDateTimeFormat } from "../../helpers/dateTimeFormat";
import { getAllAuthenticationHistory, getAuthenticationHistoryByID, resetSelected } from "../../redux/slices/authentication-history-slice";
import moment from "moment";
import { toast } from "react-toastify";
import { transactionStatusConstant, transactionStatusOptions, transactionTypeOptions } from "../../constants/app-constants";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { useLocation } from "react-router";
import { Menus } from "../../constants/menus-constant";
// import { resetExportData } from "../../redux/slices/authentication-history-export-slice";
import { providerInstitutionConstant } from "../../constants/user-constants";
// import { Stack } from "@mui/material";

const AuthenticationHistory = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { schemes } = useSelector((state) => state.schemesListReducer);
    const { loading, authenticationHistoryData, selectedHistoryDetails, pagination } = useSelector((state) => state.authenticationHistoryReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    let currentDateTime = new Date();
    let startDateTime = new Date(currentDateTime);
    startDateTime.setHours(currentDateTime.getHours() - 23);

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };
    const initialOrderBy = {
        sortColumn: "transactionDateTime",
        isAsce: false,
    };
    const initialSearch = {
        startDateTime: handleDateTimeFormat({ dateTime: startDateTime, normal: true }),
        endDateTime: handleDateTimeFormat({ dateTime: currentDateTime, normal: true }),
        acsTransId: '',
        merchantName: '',
        cardHolderName: '',
        cardNumber: '',
        purchaseAmount: '',
        messageCategory: '',
        schemeId: '',
        status: '',
        transactionType: '',
        institution: isProvider ? null : user?.institution?.value,
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
        isExportModalOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const defaultParams = {
        pagination: states.pagination,
        orderBy: states.orderBy,
        search: states.search
    };

    const getAllAuthenticationHistoryData = async (updatedParams) => {
        if (!states.isFiltersOpen) {
            currentDateTime = new Date();
            startDateTime = new Date(currentDateTime);
            startDateTime.setHours(currentDateTime.getHours() - 23);

            setStates((old) => ({
                ...old,
                search: {
                    ...old.search,
                    startDateTime: handleDateTimeFormat({ dateTime: startDateTime, normal: true }),
                    endDateTime: handleDateTimeFormat({ dateTime: currentDateTime, normal: true }),
                }
            }))
        }

        if (user && updatedParams) {
            const startDate = moment(states.search.startDateTime);
            const endDate = moment(states.search.endDateTime);

            const formatedStartDateTime = startDate.format('DD-MM-YYYY HH:mm:ss');
            const formatedEndDateTime = endDate.format('DD-MM-YYYY HH:mm:ss');

            if (startDate?.isAfter(endDate)) {
                toast.error('Start DateTime cannot be greater than End DateTime');
                return;
            }

            const updateParam = {
                ...updatedParams,
                search: {
                    ...updatedParams.search,
                    startDateTime: formatedStartDateTime,
                    endDateTime: formatedEndDateTime,
                }
            };

            dispatch(getAllAuthenticationHistory({ user, ...updateParam }));
        }
    };

    // const handleReload = () => {
    //     getAllAuthenticationHistoryData(defaultParams);
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getAllAuthenticationHistoryData(params);
    };

    // const handleChangeFilters = (e) => {
    //     const { name, value, type, checked } = e.target;

    //     setStates((old) => ({
    //         ...old,
    //         search: {
    //             ...old.search,
    //             [name]: ['startDateTime', 'endDateTime'].includes(name)
    //                 ? handleDateTimeFormat({ dateTime: value, normal: true })
    //                 : ['checkbox', 'radio'].includes(type)
    //                 ? checked
    //                 // : ['purchaseAmount'].includes(name)
    //                 // ? Number(value)
    //                 : value,
    //         },
    //     }));
    // };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    // const handleToggleFilters = () => {
    //     setStates((old) => ({ ...old, search: initialSearch, isFiltersOpen: !states.isFiltersOpen }));
    // };

    const handleModalOpen = (id) => {
        if (id) {
            dispatch(getAuthenticationHistoryByID({ user, id })).then((action) => {
                if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                    setStates((old) => ({ ...old, isModalOpen: true }));
                }
            });
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null, isUpdate: false, isView: false }));
        dispatch(resetSelected());
    };

    // const handleExportModalOpen = () => {
    //     setStates((old) => ({ ...old, isExportModalOpen: true }));
    //     dispatch(resetExportData());
    // };

    // const handleExportModalClose = () => {
    //     setStates((old) => ({ ...old, isExportModalOpen: false }));
    //     dispatch(resetExportData());
    // };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        const params = {
            ...defaultParams,
            search: searchToUse,
            pagination: initialPagination,
        };
        getAllAuthenticationHistoryData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search, [key]: value || '' };
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

    const actions = (id) => {
        const actionsList = [
            { label: 'View more', action: () => handleModalOpen(id) },
        ];

        return actionsList;
    };

    useEffect(() => {
        getAllAuthenticationHistoryData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (authenticationHistoryData && Array.isArray(authenticationHistoryData)) {
            setStates((old) => ({ ...old, data: authenticationHistoryData, pagination: pagination }));
        }
    }, [authenticationHistoryData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const searchFields = [
    //     {
    //         label: 'Start Date Time',
    //         type: 'datetime-local',
    //         placeholder: 'Search by start datetime',
    //         name: 'startDateTime',
    //         value: states?.search?.startDateTime,
    //     },
    //     {
    //         label: 'End Date Time',
    //         type: 'datetime-local',
    //         placeholder: 'Search by end datetime',
    //         name: 'endDateTime',
    //         value: states?.search?.endDateTime,
    //     },
    //     {
    //         label: 'ACS Transaction ID',
    //         type: 'text',
    //         placeholder: 'Search by transaction ID',
    //         name: 'acsTransId',
    //         value: states.search.acsTransId,
    //     },
    //     {
    //         label: 'Merchant Name',
    //         type: 'text',
    //         placeholder: 'Search by merchant name',
    //         name: 'merchantName',
    //         value: states.search.merchantName,
    //     },
    //     {
    //         label: 'Card Holder Name',
    //         type: 'text',
    //         placeholder: 'Search by card holder',
    //         name: 'cardHolderName',
    //         value: states.search.cardHolderName,
    //     },
    //     {
    //         label: 'Card Number',
    //         type: 'number',
    //         placeholder: 'Search by card number',
    //         name: 'cardNumber',
    //         value: states.search.cardNumber,
    //     },
    //     {
    //         label: 'Amount',
    //         type: 'number',
    //         placeholder: 'Search by amount',
    //         name: 'purchaseAmount',
    //         value: states?.search?.purchaseAmount,
    //     },
    //     {
    //         label: 'Message Category',
    //         type: 'text',
    //         placeholder: 'Search by category',
    //         name: 'messageCategory',
    //         value: states?.search?.messageCategory,
    //     },
    //     {
    //         label: 'Scheme',
    //         type: 'select',
    //         options: schemes?.map(e => ({ label: e?.name, value: e?.id })),
    //         name: 'schemeId',
    //         value: states.search.schemeId,
    //     },
    //     {
    //         label: 'Status',
    //         type: 'select',
    //         options: transactionStatusOptions,
    //         name: 'status',
    //         value: states.search.status,
    //     },
    //     {
    //         label: 'Transaction Type',
    //         type: 'select',
    //         options: transactionTypeOptions,
    //         name: 'transactionType',
    //         value: states.search.transactionType,
    //     },
    //     {
    //         type: 'action',
    //         actions: [
    //             { label: 'Cancel', icon: CrossSvg, type: 'button', outline: true, action: handleToggleFilters },
    //             { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
    //         ],
    //     }
    // ];

    // TABLE COLUMNS SETUP AS PER DATA
    // const columns = [
    //     { field: 'acsTransId', headerName: 'ACS Transaction ID', width: 140 },
    //     { field: 'merchantName', headerName: 'Merchant Name', width: 130 },
    //     { field: 'cardholderName', headerName: 'Card Holder', width: 130 },
    //     { field: 'cardNumber', headerName: 'Card Number', width: 130, align: 'center' },
    //     { field: 'purchaseAmount', headerName: 'Amount', width: 130 },
    //     {
    //         field: 'status',
    //         headerName: 'Status',
    //         width: 100,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.status &&
    //                         <BadgeComponent
    //                             label={row?.status?.toLowerCase()}
    //                             type={{
    //                                 [transactionStatusConstant?.pass]: 'success',
    //                                 [transactionStatusConstant.pending]: 'warning',
    //                                 [transactionStatusConstant.fail]: 'error'
    //                             }[row?.status] || 'default'}
    //                         />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.status,
    //     },
    //     {
    //         field: 'creqStatus',
    //         headerName: 'C-REQ Status',
    //         width: 120,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.creqStatus &&
    //                         <BadgeComponent
    //                             label={row?.creqStatus?.toLowerCase()}
    //                             outline
    //                             type={{
    //                                 [transactionReqStatusConstant?.success]: 'success',
    //                                 [transactionReqStatusConstant?.failed]: 'error',
    //                                 [transactionReqStatusConstant?.pending]: 'warning',
    //                             }[row?.creqStatus] || 'default'}
    //                         />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.creqStatus,
    //     },
    //     {
    //         field: 'cresStatus',
    //         headerName: 'C-RES Status',
    //         width: 120,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.cresStatus &&
    //                         <BadgeComponent
    //                             label={row?.cresStatus?.toLowerCase()}
    //                             outline
    //                             type={{
    //                                 [transactionReqStatusConstant?.success]: 'success',
    //                                 [transactionReqStatusConstant?.failed]: 'error',
    //                                 [transactionReqStatusConstant?.pending]: 'warning',
    //                             }[row?.cresStatus] || 'default'}
    //                         />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.cresStatus,
    //     },
    //     {
    //         field: 'transactionType',
    //         headerName: 'Transaction Type',
    //         width: 140,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.transactionType &&
    //                         <BadgeComponent
    //                             label={row?.transactionType}
    //                             outline
    //                         />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.transactionType,
    //     },
    //     // {
    //     //     field: 'rreqStatus',
    //     //     headerName: 'R-REQ Status',
    //     //     width: 120,
    //     //     align: 'center',
    //     //     valueGetter: (row) => {
    //     //         return (
    //     //             <>
    //     //                 {
    //     //                     row?.rreqStatus &&
    //     //                     <BadgeComponent
    //     //                         label={row?.rreqStatus?.toLowerCase()}
    //     //                         outline
    //     //                         type={{
    //     //                             [transactionReqStatusConstant?.success]: 'success',
    //     //                             [transactionReqStatusConstant?.failed]: 'error',
    //     //                             [transactionReqStatusConstant?.pending]: 'warning',
    //     //                         }[row?.rreqStatus] || 'default'}
    //     //                     />
    //     //                 }
    //     //             </>
    //     //         )
    //     //     },
    //     //     sortBy: (row) => row?.rreqStatus,
    //     // },
    //     // {
    //     //     field: 'rresStatus',
    //     //     headerName: 'R-RES Status',
    //     //     width: 120,
    //     //     align: 'center',
    //     //     valueGetter: (row) => {
    //     //         return (
    //     //             <>
    //     //                 {
    //     //                     row?.rresStatus &&
    //     //                     <BadgeComponent
    //     //                         label={row?.rresStatus?.toLowerCase()}
    //     //                         outline
    //     //                         type={{
    //     //                             [transactionReqStatusConstant?.success]: 'success',
    //     //                             [transactionReqStatusConstant?.failed]: 'error',
    //     //                             [transactionReqStatusConstant?.pending]: 'warning',
    //     //                         }[row?.rresStatus] || 'default'}
    //     //                     />
    //     //                 }
    //     //             </>
    //     //         )
    //     //     },
    //     //     sortBy: (row) => row?.rresStatus,
    //     // },
    //     { field: 'messageCategory', headerName: 'Message Category', width: 130 },
    //     {
    //         field: 'messageVersionId', headerName: 'Message Version', width: 120, align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.messageVersionId &&
    //                         <BadgeComponent label={row?.messageVersionId?.version} outline />
    //                     }
    //                 </>
    //             )
    //         }
    //     },
    //     {
    //         field: 'schemeId', headerName: 'Scheme', width: 120, align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.schemeId &&
    //                         <BadgeComponent label={row?.schemeId?.name} />
    //                     }
    //                 </>
    //             )
    //         }
    //     },
    //     { field: 'transactionDateTime', headerName: 'Date & Time', width: 170, align: 'center' },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions(row?.acsTransId)} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];

    const columns = useMemo(() => [
        {
            accessor: 'transactionDateTime',
            Header: 'Date & Time',
            minWidth: 180,
            style: { textAlign: 'center' },
            // Filter: ({ filter, onChange }) => (
            //     <Stack direction="column" spacing={0.3}>
            //         <input
            //             type="datetime-local"
            //             name="startDateTime"
            //             value={filter ? filter.value : ''}
            //             onChange={(e) => {
            //                 const value = e.target.value;
            //                 onChange(value);
            //                 handleTableFilterChange('startDateTime', value, true);
            //             }}
            //             style={{ width: '100%' }}
            //         />
            //         <input
            //             type="datetime-local"
            //             name="endDateTime"
            //             value={filter ? filter.value : ''}
            //             onChange={(e) => {
            //                 const value = e.target.value;
            //                 onChange(value);
            //                 handleTableFilterChange('endDateTime', value, true);
            //             }}
            //             style={{ width: '100%' }}
            //         />
            //     </Stack >
            // ),
            sortable: false,
            filterable: false
        },
        {
            accessor: 'acsTransId',
            Header: 'ACS Transaction ID',
            minWidth: 190,
            style: {
                textAlign: 'center'
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="acsTransId"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('acsTransId', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('acsTransId', value, true);
                        }
                    }}
                    placeholder="Search by transaction ID"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
            // filterable: false,
        },
        {
            accessor: 'merchantName',
            Header: 'Merchant Name',
            minWidth: 200,
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="merchantName"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('merchantName', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('merchantName', value, true);
                        }
                    }}
                    placeholder="Search by merchant name"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
            // filterable: false,
        },
        {
            accessor: 'cardholderName',
            Header: 'Card Holder',
            minWidth: 190,
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="cardHolderName"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('cardHolderName', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('cardHolderName', value, true);
                        }
                    }}
                    placeholder="Search by card holder"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
            // filterable: false,
        },
        {
            accessor: 'cardNumber',
            Header: 'Card Number',
            minWidth: 180,
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="cardNumber"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('cardNumber', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('cardNumber', value, true);
                        }
                    }}
                    placeholder="Search by card number"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
            // filterable: false,
        },
        {
            accessor: 'purchaseAmount',
            Header: 'Amount',
            minWidth: 140,
            style: { textAlign: 'center' },
            Filter: ({ filter, onChange }) => (
                <input
                    type="number"
                    name="purchaseAmount"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('purchaseAmount', value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
                            const value = e.target.value === '' ? undefined : e.target.value;
                            onChange(value);
                            handleTableFilterChange('purchaseAmount', value, true);
                        }
                    }}
                    placeholder="Search by amount"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'status',
            Header: 'Status',
            minWidth: 150,
            style: { textAlign: 'center' },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.status &&
                            <BadgeComponent
                                label={row?.original?.status?.toLowerCase()}
                                type={{
                                    [transactionStatusConstant?.pass]: 'success',
                                    [transactionStatusConstant.pending]: 'warning',
                                    [transactionStatusConstant.fail]: 'error'
                                }[row?.original?.status] || 'default'}
                            />
                        }
                    </>
                )
            },
            Filter: ({ filter, onChange }) => (
                <select
                    name="status"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('status', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        transactionStatusOptions?.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            sortable: false,
            // filterable: false,
        },
        // {
        //     accessor: 'creqStatus',
        //     Header: 'C-REQ Status',
        //     minWidth: 150,
        //     style: { textAlign: 'center' },
        //     Cell: (row) => {
        //         return (
        //             <>
        //                 {
        //                     row?.original?.creqStatus &&
        //                     <BadgeComponent
        //                         label={row?.original?.creqStatus?.toLowerCase()}
        //                         // outline
        //                         type={{
        //                             [transactionReqStatusConstant?.success]: 'success',
        //                             [transactionReqStatusConstant?.failed]: 'error',
        //                             [transactionReqStatusConstant?.pending]: 'warning',
        //                         }[row?.original?.creqStatus] || 'default'}
        //                     />
        //                 }
        //             </>
        //         )
        //     },
        //     sortable: false,
        //     filterable: false,
        // },
        // {
        //     accessor: 'cresStatus',
        //     Header: 'C-RES Status',
        //     minWidth: 150,
        //     style: { textAlign: 'center' },
        //     Cell: (row) => {
        //         return (
        //             <>
        //                 {
        //                     row?.original?.cresStatus &&
        //                     <BadgeComponent
        //                         label={row?.original?.cresStatus?.toLowerCase()}
        //                         // outline
        //                         type={{
        //                             [transactionReqStatusConstant?.success]: 'success',
        //                             [transactionReqStatusConstant?.failed]: 'error',
        //                             [transactionReqStatusConstant?.pending]: 'warning',
        //                         }[row?.original?.cresStatus] || 'default'}
        //                     />
        //                 }
        //             </>
        //         )
        //     },
        //     sortable: false,
        //     filterable: false,
        // },
        {
            accessor: 'transactionType',
            Header: 'Transaction Type',
            minWidth: 150,
            style: { textAlign: 'center' },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.transactionType &&
                            <BadgeComponent
                                label={row?.original?.transactionType}
                            // outline
                            />
                        }
                    </>
                )
            },
            Filter: ({ filter, onChange }) => (
                <select
                    name="transactionType"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('transactionType', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        transactionTypeOptions?.map((item, index) => (
                            <option key={index} value={item.value}>
                                {item.label}
                            </option>
                        ))
                    }
                </select>
            ),
            sortable: false,
            // filterable: false,
        },
        // {
        //     field: 'rreqStatus',
        //     headerName: 'R-REQ Status',
        //     width: 120,
        //     align: 'center',
        //     valueGetter: (row) => {
        //         return (
        //             <>
        //                 {
        //                     row?.rreqStatus &&
        //                     <BadgeComponent
        //                         label={row?.rreqStatus?.toLowerCase()}
        //                         outline
        //                         type={{
        //                             [transactionReqStatusConstant?.success]: 'success',
        //                             [transactionReqStatusConstant?.failed]: 'error',
        //                             [transactionReqStatusConstant?.pending]: 'warning',
        //                         }[row?.rreqStatus] || 'default'}
        //                     />
        //                 }
        //             </>
        //         )
        //     },
        //     sortBy: (row) => row?.rreqStatus,
        // },
        // {
        //     field: 'rresStatus',
        //     headerName: 'R-RES Status',
        //     width: 120,
        //     align: 'center',
        //     valueGetter: (row) => {
        //         return (
        //             <>
        //                 {
        //                     row?.rresStatus &&
        //                     <BadgeComponent
        //                         label={row?.rresStatus?.toLowerCase()}
        //                         outline
        //                         type={{
        //                             [transactionReqStatusConstant?.success]: 'success',
        //                             [transactionReqStatusConstant?.failed]: 'error',
        //                             [transactionReqStatusConstant?.pending]: 'warning',
        //                         }[row?.rresStatus] || 'default'}
        //                     />
        //                 }
        //             </>
        //         )
        //     },
        //     sortBy: (row) => row?.rresStatus,
        // },
        // { 
        //     accessor: 'messageCategory', 
        //     Header: 'Message Category', 
        //     minWidth: 160,
        //     style: { textAlign: 'center' },
        //     Filter: ({ filter, onChange }) => (
        //         <input
        //             type="text"
        //             name="messageCategory"
        //             value={filter ? filter.value : ''}
        //             onChange={(e) => {
        //                 const value = e.target.value;
        //                 onChange(value);
        //                 handleTableFilterChange('messageCategory', value);
        //             }}
        //             onKeyDown={(e) => {
        //                 if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
        //                     const value = e.target.value === '' ? undefined : e.target.value;
        //                     onChange(value);
        //                     handleTableFilterChange('messageCategory', value, true);
        //                 }
        //             }}
        //             placeholder="Search by category"
        //             style={{ width: '100%' }}
        //         />
        //     ),
        //     sortable: false,
        // },
        // {
        //     accessor: 'messageVersionId', 
        //     Header: 'Message Version', 
        //     minWidth: 150, 
        //     style: { textAlign: 'center' },
        //     Cell: (row) => {
        //         return (
        //             <>
        //                 {
        //                     row?.original?.messageVersionId &&
        //                     <BadgeComponent label={row?.original?.messageVersionId?.version} outline />
        //                 }
        //             </>
        //         )
        //     },
        //     sortable: false,
        //     filterable: false,
        // },
        {
            accessor: 'schemeId',
            Header: 'Scheme',
            minWidth: 160,
            style: { textAlign: 'center' },
            // Cell: (row) => {
            //     return (
            //         <>
            //             {
            //                 row?.original?.schemeId &&
            //                 <BadgeComponent label={row?.original?.schemeId?.name} />
            //             }
            //         </>
            //     )
            // },
            Cell: (row) => {
                const scheme = row?.original?.schemeId;
                if (scheme?.logoDataUri) {
                    return <img src={scheme?.logoDataUri} alt={scheme?.name} style={{ width: '100%', maxWidth: 40, height: 'auto' }} />;
                }
                return null;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    name="schemeId"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('schemeId', value, true);
                    }}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {
                        schemes?.map((item, index) => (
                            <option key={index} value={item.id}>
                                {item.name}
                            </option>
                        ))
                    }
                </select>
            ),
            sortable: false,
            // filterable: false,
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions(row?.original?.acsTransId)} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [states.isDropdownOpen, states.selected, schemes]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Authentication History</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>

                <div className="right">
                    {/* <ButtonComponent 
                        icon={FileSvg} 
                        label="Export" 
                        size="small"
                        disabled={loading} 
                        onClick={handleExportModalOpen}
                    /> */}
                    {/* <ButtonComponent icon={FilterSvg} label="Filter" size="small" outline disabled={loading} onClick={handleToggleFilters} /> */}
                </div>
            </AuthPageHead>

            {/* FILTER */}
            {/* {
                searchFields && searchFields.length > 0 &&
                <FiltersComponent open={states.isFiltersOpen} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} />
            } */}

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/* {
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            } */}

            {/* PAGE CONTENT */}
            {
                // !loading && states.data && states.data.length > 0 &&
                // <Fragment>
                //     <TableComponent rows={states.data} columns={columns} icon={HistorySvg} />
                //     <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} />
                // </Fragment>
                <>
                    <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={true}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen && selectedHistoryDetails &&
                <ViewHistoryModal data={selectedHistoryDetails?.log} logs={selectedHistoryDetails} label='History Details' close={handleModalClose} slide />
            }

            {/* EXPORT MODAL */}
            {/* {
                states.isExportModalOpen &&
                <AuthHistoryExportModal close={handleExportModalClose} slide />
            } */}
        </AuthPageContainer>
    );
};

export default AuthenticationHistory;